import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom"
import queryString from 'query-string'

class TableRowStatistic extends Component {
    render() {
        const {type, level, query, value, typeRow} = this.props
        const newQuery = queryString.parse(query)
        const {hasNote = ''} = Object.assign({}, newQuery)

        return (
            type === '' ? <td className={typeRow}>
                    <strong className={level}>
                        <Link
                            to={{
                                pathname: "/admin",
                                search: hasNote === 'n' ? `${query}&valueOvertime=${value}` : query
                            }}
                            target={'_blank'}
                        >
                            {value}
                        </Link>
                    </strong>
                </td>
                :
                <td className={level}>
                    <Link
                        to={{
                            pathname: "/admin",
                            search: hasNote === 'n' ? `${query}&valueOvertime=${value}` : query
                        }}
                        target={'_blank'}
                    >
                        {value}
                    </Link>
                </td>
        )
    }
}

TableRowStatistic.propTypes = {
    typeRow: PropTypes.string,
    type: PropTypes.string.isRequired,
    level: PropTypes.string,
    query: PropTypes.string,
    value: PropTypes.string
}

export default TableRowStatistic